import axios from '../axios';
import {
  ONLOAD_INFORMATION_API,
  PHONE_VERIFICATION_SMS,
  TEMPORARY_PHONE_VERIFICATION_SMS,
  MERCHANT_CONTACT_REQUEST,
  MARKETING_AVAILABLE_TIME_SLOTS,
  REPORT_UI_BUG_API,
} from '../ApiUrl';

// Hedaer is added just for testing to capture header getting with this API,we can also pass header with mob header extention
export const onLoadInformationAPI = async (payload) => {
  try {
    const response = await axios.post(ONLOAD_INFORMATION_API, payload, {
      headers: {
        syed: 'syed',
      },
    });
    return response;
  } catch (error) {
    console.log('onLoadInformationAPI  catch block', error);
    return { success: false, error };
  }
};

export const onPhoneVerificationAPI = async (payload) => {
  try {
    const response = await axios.post(PHONE_VERIFICATION_SMS, payload);
    return response;
  } catch (error) {
    console.log('onPhoneVerificationAPI  catch block', error);
    return { success: false, error };
  }
};

/** Public temp phone OTP (Twilio) — no JWT / kitchen update */
export const onTemporaryPhoneVerificationAPI = async (payload) => {
  try {
    const response = await axios.post(TEMPORARY_PHONE_VERIFICATION_SMS, payload);
    return response;
  } catch (error) {
    console.log('onTemporaryPhoneVerificationAPI  catch block', error);
    return { hasError: true, success: false, error };
  }
};

/** Public merchant contact lead after phone OTP verify */
export const onMerchantContactRequestAPI = async (payload) => {
  try {
    const response = await axios.post(MERCHANT_CONTACT_REQUEST, payload);
    return response;
  } catch (error) {
    console.log('onMerchantContactRequestAPI catch block', error);
    return { hasError: true, success: false, error };
  }
};

/** Public marketing appointment slots for the full month of the given date */
export const onMarketingAvailableTimeSlotsAPI = async (payload) => {
  try {
    const response = await axios.post(MARKETING_AVAILABLE_TIME_SLOTS, payload);
    return response;
  } catch (error) {
    console.log('onMarketingAvailableTimeSlotsAPI catch block', error);
    return { hasError: true, success: false, error };
  }
};

// RepotUIbug Api Call
export const reportUiBugApi = async (payload) => {
  try {
    const response = await axios.post(REPORT_UI_BUG_API, payload);
    return response;
  } catch (error) {
    console.log('REPORT_UI_BUG_API catch error', error);
    return error;
  }
};
